import axios from 'axios';
import config from '../../config';

export const getFileServerAllApi = async () => {
   const url = `${config.apiUrl}/v1/fileServer/`;
   return await axios.get(url)
      .then(response => response.data)
}
export const getFileServerByFileServerIdApi = (fileServerId) => {
   const url = `${config.apiUrl}/v1/fileServer/${fileServerId}`;
   return axios.get(url)
      .then(response => response.data);
}
export const getStoreInformationByISBNApi = (isbn) => {
   const url = `${config.apiUrl}/v1/fileServer/store/${isbn}`;
   return axios.get(url)
      .then(response => response.data);
}

export const postSaveFileServerApi = (fileServer) => {
   const url = `${config.apiUrl}/v1/fileServer/`;
   return axios.post(url, fileServer)
      .then(response => response.data);
}

export const copyFileServerApi = (id) => {
   const url = `${config.apiUrl}/v1/fileServer/copy/${id}`;
   return axios.post(url, {}, { timeout: 0 })
      .then(response => response.data);
}

export const putUpdateFileServerApi = (fileServer) => {
   const url = `${config.apiUrl}/v1/fileServer/`;
   return axios.put(url, fileServer)
      .then(response => response.data);
}
export const deleteMultiFileServerApi = (fileServerIdList) => {
   const url = `${config.apiUrl}/v1/fileServer/`;
   return axios.delete(url, { data: fileServerIdList })
      .then(response => response.data);
}

export const deleteFileServerApi = (id) => {
   const url = `${config.apiUrl}/v1/fileServer/${id}`;
   return axios.delete(url)
      .then(response => response.data);
}

export const postUploadFileServerFileApi = async (formData, onUploadProgress) => {
   //  //console.log("file upload  çalıştı");
   try {
      const url = `${config.apiUrl}/v1/fileServer/upload/file/`;
      return await axios.post(url, formData, {
         headers: {
            'Content-Type': 'multipart/form-data'
         },
         onUploadProgress
      }).then(response => response.data)

   } catch (err) {
      if (err.response.status === 500) {
         //console.log("Sunucu problemi var")
         return { status: false, errorMessage: "Sunucu problemi var" }
      }
      else {
         //console.log(err.response.data.msg);
         return { status: false, errorMessage: err.response.data.msg }
      }
   }
}

export const deleteFileServerFileApi = (file) => {
   const url = `${config.apiUrl}/v1/fileServer/upload/deleteFile`;
   return axios.post(url, file)
      .then(response => response.data);
}

export const getFileServerFileByFileIdApi = (fileId) => {
   const url = `${config.apiUrl}/v1/fileServer/upload/${fileId}`;
   return axios.get(url)
      .then(response => response.data);
}
export const getFileServerFileWatermarkByFileIdAndUserIdApi = (fileId, userId) => {
   const url = `${config.apiUrl}/v1/fileServer/upload/watermark/${fileId}/${userId}`;
   return axios.get(url, {
      method: 'GET',
      responseType: 'blob',
   })
      .then(response => {
         const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
         return file;
      });


}

export const getDigitalBookCatalogByInstApi = (inst) => {
   const url = `${config.apiUrl}/v1/fileServer/digitalBook/${inst}`;
   return axios.get(url, {
      method: 'GET',
      responseType: 'blob',
   })
      .then(response => {
         const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
         return file;
      });
}

export const getDetailedBookCatalogByInstApi = (inst) => {
   const url = `${config.apiUrl}/v1/fileServer/detailedBookCatalog/${inst}`;
   return axios.get(url, {
      method: 'GET',
      responseType: 'blob',
   })
      .then(response => {
         const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
         return file;
      })
      .catch(error => {
         console.error("Detaylı katalog indirme hatası:", error);
         throw error;
      });
}



export const getArchiveSearchApi = (search, searchType) => {
   const url = `${config.apiUrl}/v1/fileServer/search/${search}?searchType=${searchType}`;
   return axios.get(url)
      .then(response => response.data);
}

export const openWebSelected = async (data) => {
   const url = `${config.apiUrl}/v1/fileServer/openWebSelected`;
   return axios.post(url, data)
      .then(response => response.data);
}

export const getFileServerAuthorsTableNameByBookIdApi = async (bookId) => {
   const url = `${config.apiUrl}/v1/fileServer/authorsTableName/${bookId}`;
   return axios.get(url)
      .then(response => response.data);
}

export const getDigitalBookCatalogApi = async (inst) => {
   const url = `${config.apiUrl}/v1/fileServer/catalog/${inst}`;
   return axios.get(url)
      .then(response => response.data);
}